<template>
  <div class="list-item template-item">
    <v-list-item-avatar tile v-if="!isMobile">
      <v-icon>mdi-clipboard-text-outline</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <div class="item-right">
        <div class="description justify-center">
          <div class="d-flex">
            <span class="font-weight-bold">
              {{ interviewFormatTemplate.interviewName }}
              ({{ interviewFormatTemplate.duration }} mins)
            </span>
          </div>
          <div class="status-wrapper secondary-text">
            <span class="mr-1 mt-1">
              {{ interviewFormatTemplate.formattedTags }}
            </span>
          </div>
        </div>
      </div>
    </v-list-item-content>
  </div>
</template>

<script>
export default {
  props: {
    interviewFormatTemplate: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scope></style>
